/**
 * Created by Markus on 15.6.2015.
 */

define('helperNavigation-isLevel1NoChildren',[],function() {
    'use strict';

    var isLevel1NoChildren = function(ID, arr) {
        var noChildren = false;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        arr = [].concat(arr);

        if(arr.length > 0) {
            noChildren = (arr.some(function (entity) {
                if (entity.hasOwnProperty('contentEntityId') && entity.contentEntityId === ID) {
                    if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length) {
                        // has children
                        return false;
                    }else{
                        return true;
                    }
                }
            })) ? true: false;
        }

        return noChildren;
    };

    return isLevel1NoChildren;

});

